import cx from 'classnames';
import { capitalize } from 'lodash';
import * as React from 'react';

import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import OrganizationEngagementBadge from 'organizations/components/OrganizationEngagementBadge';
import { EngagementRating } from 'organizations/constants/EngagementRatings';

import OrganizationEngagementViewContainer from './OrganizationEngagementViewContainer';
import OrganizationEngagementViewHeading from './OrganizationEngagementViewHeading';
import OrganizationEngagementViewSection from './OrganizationEngagementViewSection';

import './OrganizationEngagementViewContentHeader.scss';

type Props = {
  city?: string;
  eventKey: string;
  name?: string;
  onShowRatingsModal: () => void;
  schoolRating?: EngagementRating | undefined;
  state?: string;
};

export default function OrganizationEngagementViewContentHeader({
  city,
  eventKey,
  name,
  onShowRatingsModal,
  schoolRating,
  state,
}: Props) {
  return (
    <OrganizationEngagementViewSection
      theme="dark"
      className={cx(
        'OrganizationEngagementViewContentHeader',
        !schoolRating && 'OrganizationEngagementViewContentHeader--noRating'
      )}>
      <OrganizationEngagementViewContainer className="OrganizationEngagementViewContentHeader-container">
        <Text align="center">
          {city && state && (
            <Row size="xxsmall">
              <Text size="large">
                {city}, {state}
              </Text>
            </Row>
          )}
          {name && (
            <OrganizationEngagementViewHeading element="h1">
              {name}
            </OrganizationEngagementViewHeading>
          )}
          <MediaObject center gutter="medium" inline>
            {schoolRating && (
              <OrganizationEngagementBadge
                rating={schoolRating}
                size="small"
                onClick={onShowRatingsModal}
              />
            )}
            <Text align="left" element="div" size="medium">
              <Row size="xsmall">
                <Text element="h2" size="large">
                  {schoolRating ? (
                    <React.Fragment>
                      Featured engagement rating:{' '}
                      <Text weight="semibold">{capitalize(schoolRating)}</Text>
                    </React.Fragment>
                  ) : (
                    'An engagement rating isn’t available for this district.'
                  )}
                </Text>
              </Row>
              <Link
                weight="semibold"
                className="OrganizationEngagementView-link"
                onClick={onShowRatingsModal}
                eventKey={`${eventKey}.content_header.ratings_modal_cta.click`}>
                What does this mean?
              </Link>
            </Text>
          </MediaObject>
        </Text>
      </OrganizationEngagementViewContainer>
    </OrganizationEngagementViewSection>
  );
}
